import React from 'react'

import { colors } from '@flowwai-frontend/shared/style-guide'

import { IconPropsType } from '../types'

const Image03Icon = (props: IconPropsType) => {
   const {
      fill = colors['primary-600'],
      width = 24,
      height = 24,
      ...rest
   } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         viewBox='0 0 24 24'
         fill='none'
         {...rest}
      >
         <path
            fill={fill}
            fillRule='evenodd'
            d='M8 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z'
            clipRule='evenodd'
         />
         <path
            fill={fill}
            fillRule='evenodd'
            d='M17.241 2H6.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C1 6.29 1 6.954 1 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392.119.01.243.017.374.023l.022.002c.214.019.48.019.75.019h12.212c.27 0 .536 0 .75-.019l.022-.002c.13-.006.255-.014.374-.023.562-.046 1.079-.145 1.564-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V7.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 2 18.046 2 17.242 2ZM21 12.586V7.8c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18C18.639 4 18.057 4 17.2 4H6.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C3 6.361 3 6.943 3 7.8v8.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .739.798c.058-.088.116-.158.158-.209.138-.165.326-.352.517-.544l5.552-5.551c.179-.179.352-.353.512-.488.174-.148.396-.308.686-.402a2 2 0 0 1 1.236 0c.29.094.512.254.687.402.159.135.332.31.511.488l.184.184 2.184-2.184a9.18 9.18 0 0 1 .511-.488c.175-.148.397-.308.687-.402a2 2 0 0 1 1.236 0c.29.094.512.254.687.402.159.135.332.31.51.488L21 12.586Z'
            clipRule='evenodd'
         />
      </svg>
   )
}

export default Image03Icon
